import React from 'react'

function AboutCompony() {
  return (
    <div className='c-about-Compony'>
        <div className='about-Compony'>
            <div className='about-C-item'> 
                <img className='img-about' src="image/vector-pic-about.jpg" alt="" />
            </div>
            <div className='about-C-item'>
                  <p className='title-about'>  About </p>
                  <div className='textJustify'> We operate in the field of supply and distribution of all kinds of iron and construction stones and we respond to the needs of construction and industrial projects by providing high quality products. The iron group includes products such as beams, rebars, corners and profiles, which are used in the construction of strong and safe structures. Our goal is to provide high standard products and complete customer satisfaction. </div>
                  {/* <div className='btn-abotu'> Lorem ipsum  </div> */}
            </div>
        </div>
    </div>
  )
}

export default AboutCompony
